export default "__VITE_ASSET__d148b800__"